import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const FistulaPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Fistula</h1>
        <section className="mb-8">
          <p>A fistula is an abnormal connection between two body parts, often occurring in the anal region. It can cause discomfort, pain, and recurrent infections. Our natural therapies focus on healing the fistula tract, reducing inflammation, and preventing recurrence without invasive procedures.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Anal abscess</li>
            <li>Inflammatory bowel disease</li>
            <li>Infection</li>
            <li>Trauma</li>
            <li>Previous surgery</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Pain and discomfort</li>
            <li>Swelling and inflammation</li>
            <li>Recurrent infections</li>
            <li>Discharge or drainage</li>
            <li>Difficulty with bowel movements</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use healing herbs, natural remedies, and lifestyle modifications to treat fistula without surgery. Our approach focuses on promoting natural healing, reducing inflammation, and preventing recurrence through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Non-surgical treatment</li>
            <li>Reduces pain and inflammation</li>
            <li>Promotes natural healing</li>
            <li>Prevents recurrence</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Maintain good hygiene</li>
            <li>Eat a fiber-rich diet</li>
            <li>Stay hydrated</li>
            <li>Avoid straining during bowel movements</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment heal fistula without surgery?</strong>
            <p>A: Yes, our natural approach can effectively treat many cases of fistula without surgical intervention.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment painful?</strong>
            <p>A: Our treatments are gentle and focus on reducing pain and discomfort.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How long does treatment take?</strong>
            <p>A: Treatment duration varies, but many patients see improvement within a few months.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from fistula—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default FistulaPage; 